import React from 'react';
import { Form, Input, Card, Row, Col } from 'antd';
import './RelatedLinkWithPreview.css';

function RelatedLinkWithPreview(props) {
    const hasPreview = props.url && props.url.trim() && props.text && props.text.trim();
    
    return (
        <div className="related-link-preview-columns">
            <Form.Item label={props.label} style={{ width: '50%' }}>
                <div>
                    <Form.Item label="Link URL" style={{ marginBottom: 8 }}>
                        <Input
                            placeholder="https://dailybruin.com/2025/11/25/article-slug"
                            value={props.url}
                            onChange={e => props.onUrlChange(e.target.value)}
                            size="small"
                            disabled={props.isFetchingTitle}
                        />
                        {props.isFetchingTitle && (
                            <span style={{ fontSize: '12px', color: '#1890ff', marginLeft: 8 }}>
                                Fetching title...
                            </span>
                        )}
                    </Form.Item>
                    <Form.Item label="Link text" style={{ marginBottom: 0 }}>
                        <Input
                            placeholder="Text to embed (e.g. 'Read more here')"
                            value={props.text}
                            onChange={e => props.onTextChange(e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                </div>
            </Form.Item>
            {hasPreview && (
                <Row style={{ width: '50%', marginBottom: '24px', marginLeft: '1em' }}>
                    <Col>
                        <label className="preview-label">Preview:</label>
                    </Col>
                    <Col style={{ flexGrow: 1 }}>
                        <Card
                            size='small'
                            style={{ height: '100%', textAlign: 'left' }}
                        >
                            <p style={{ margin: 0 }}>
                                [Related Links:{" "}
                                <a href={props.url} target="_blank" rel="noopener noreferrer">
                                    {props.text}
                                </a>
                                ]
                            </p>
                        </Card>
                    </Col>
                </Row>
            )}
        </div>
    );
}

export default RelatedLinkWithPreview;

